import { Globe, ShieldCheck, Users, MapPin, Briefcase, Landmark } from "lucide-react";

const BENEFITS = [
  {
    title: "Full UAE Market Access",
    description:
      "Trade directly with any customer in the UAE, bid for government contracts, and operate from anywhere in the country.",
    icon: Globe,
  },
  {
    title: "100% Foreign Ownership",
    description:
      "Modern UAE law allows 100% foreign ownership in most mainland sectors no local partner required.",
    icon: ShieldCheck,
  },
  {
    title: "No Restrictions on Clients",
    description:
      "Mainland companies can serve any client government, private, local, or international.",
    icon: Users,
  },
  {
    title: "Any Location",
    description:
      "Set up your office anywhere in the UAE Dubai, Abu Dhabi, Sharjah, or any other emirate.",
    icon: MapPin,
  },
  {
    title: "More Business Activities",
    description:
      "Access to the full range of DED-approved activities with no sector restrictions.",
    icon: Briefcase,
  },
  {
    title: "Government Contracts",
    description:
      "Only mainland companies are eligible to bid for and win UAE federal and local government contracts.",
    icon: Landmark,
  },
];

export default function BenefitsSection() {
  return (
    <section className="relative py-14 sm:py-16 lg:py-20 xl:py-14 2xl:py-28 px-4 sm:px-6 lg:px-14 bg-[#FAFAFA]">

      {/* 🔥 SUPER CONTAINER (BIG SCREEN FIX) */}
      <div className="w-full mx-auto 
        max-w-[1300px] 
        lg:max-w-[1500px] 
        xl:max-w-[1700px] 
        2xl:max-w-[2000px] 
        3xl:max-w-[2200px]">

        {/* TOP TEXT */}
        <div className="text-center mb-14 sm:mb-16 lg:mb-20 xl:mb-24 max-w-5xl mx-auto">
          <p className="text-xs sm:text-sm lg:text-base font-semibold tracking-[0.15em] uppercase text-[#B8893A] mb-3 sm:mb-4">
            Advantages
          </p>

          <h2 className="font-bold text-[#000000] leading-tight mb-4 sm:mb-5
            text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[3rem] 2xl:text-[3.4rem] 3xl:text-[3.8rem]">
            Advantages of{" "}
            <span className="text-[#000000]">Mainland Setup</span>
          </h2>
        </div>

        {/* GRID */}
        <div className="grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-3 
          xl:grid-cols-3 
          2xl:grid-cols-3 
          3xl:grid-cols-3 
          gap-5 sm:gap-6 lg:gap-7 xl:gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;

            return (
              <div
                key={i}
                className="group bg-[#fafafa] border border-gray-100 rounded-xl sm:rounded-[16px] p-5 sm:p-6 lg:p-7
                           shadow-sm hover:shadow-xl transition-all duration-300"
              >
                {/* ICON + TITLE */}
                <div className="flex items-start gap-3">
                  <div className="p-2 rounded-xl bg-[#B8893A]/10 text-[#B8893A] group-hover:bg-[#B8893A] group-hover:text-white transition">
                    <Icon size={18} />
                  </div>

                  <h3 className="text-base sm:text-lg lg:text-xl xl:text-xl 2xl:text-2xl font-semibold text-black group-hover:text-[#B8893A] transition">
                    {b.title}
                  </h3>
                </div>

                {/* LINE */}
                <div className="h-px bg-black/10 my-5"></div>

                {/* DESCRIPTION */}
                <p className="text-gray-500 text-sm sm:text-base lg:text-base xl:text-md leading-relaxed">
                  {b.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* background glow */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
    </section>
  );
}
